import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { UndoButton, RedoButton } from './buttons';
import { MenuSeparator } from './MenuSeparator';

interface HistoryMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const HistoryMenu = (props: HistoryMenuProps) => {
   const { editor } = useEditorContext();

   if (!('history' in editor.storage)) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         <UndoButton />
         <RedoButton />
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
